import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { decodeQuery } from 'lib/transport';
import { QueryParams } from 'types/transport';

export const useQueryParams = <TParams extends QueryParams>() => {
  // Extract current query string
  const { search } = useLocation();

  // Parse query string into an object
  return useMemo(() => decodeQuery(search) as Readonly<Partial<TParams>>, [search]);
};
